import React, {useEffect, useState} from 'react';
import {clsx} from "clsx";

const CheckboxInput = ({
                           label,
                           checked,
                           onChange,
                           id,
                           name,
                           className,
                           color,
                           sublabel,
                           customClass,
                           classLabel,
                           classSublabel,
                           disabled = false
                       }) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleChange = (e) => {
        if (disabled) return;
        setIsChecked(e.target.checked);
        onChange(e);
        onChange({target: {name, value: e.target.checked}});
    };

    useEffect(() => {
        if (checked) setIsChecked(checked);
        else setIsChecked(false);
    }, [checked])

    return (
        <div className='flex items-start space-x-2'>
            <label className={clsx(customClass && customClass, "flex items-center relative",
                disabled ? "cursor-not-allowed" : "cursor-pointer")}
                   htmlFor={disabled ? undefined : id}>
                <input type="checkbox"
                       disabled={disabled}
                       className={clsx(className ? className : 'checked:bg-[#197D55] border-slate-300 checked:border-[#197D55] bg-white',
                           "peer h-4 w-4 transition-all appearance-none rounded shadow border",
                           disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:shadow-md")}
                       id={id}
                       checked={isChecked}
                       onChange={handleChange}/>
                <span
                    className={clsx(color ? color : 'text-white', "absolute opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none")}>
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     className="h-3.5 w-3.5"
                                     viewBox="0 0 20 20"
                                     fill="currentColor"
                                     stroke="currentColor"
                                     strokeWidth="1"
                                     clipRule="evenodd">
                                    <path fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd">
                                    </path>
                                </svg>
                            </span>
            </label>
            <label className={clsx("ml-2 text-black text-sm", classLabel,
                disabled ? "cursor-not-allowed" : "cursor-pointer")}
                   htmlFor={disabled ? undefined : id}>
                {label}
                {sublabel && <p className={clsx("text-xs text-gray-500", classSublabel)}>{sublabel}</p>}
            </label>
        </div>
    )
        ;
};

export default CheckboxInput;